/* eslint-disable react/prop-types */
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import { Box, TableCell, TableRow, Divider } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import Button from "../../../../components/common/Button";
import InputField from "../../../../components/common/new/InputField/InputField";
import OrganizationStructure from "../../../../components/common/OrganizationStructure/OrganizationStructure";
import CustomTable from "../../../../components/common/new/Table/Table";
import Toast from "../../../../components/common/Toast";
import {
  FRIEND_TRANFER_REQUEST_FIELDS,
  NEW_ENTRY_FIELDS,
  ORGANIZATION_STRUCTURE_FIELDS,
} from "../../../../contants/formFields";
import { FRIEND_TRANSFER_TO } from "../../../../contants/table/friendTransfer";
import FriendsApi from "../../../../services/api/friend";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import tableStyle from "../../../../theme/styles/table";
import { getOptions, handleTransferValidation } from "../../../../utils";
import { convertDateTimeToDate } from "../../../../utils/dateAndTime";
import SwitchButton from "../../../../components/common/SwitchButton/SwitchButton";
import Styles from "./FriendPendingForm.styles";
import { debounce } from "../../../../utils/helper";
import { ROUTES } from "../../../../utils/constants";
import Loader from "../../../../components/common/Loader/Loader";

const getRows = (row) => (
  <TableRow style={tableStyle.tableRow}>
    <TableCell>
      {" "}
      {row.fullName} <br />
      <LocationOnIcon style={tableStyle.locationIcon} /> {row.addressLine1}
    </TableCell>
    <TableCell>
      {" "}
      <PhoneIcon style={tableStyle.icon} /> {row.mobileNumber || "-"} <br />
      <EmailIcon style={tableStyle.icon} /> {row.emailId || "-"}
    </TableCell>
    <TableCell>{row.districtName || "-"} </TableCell>
    <TableCell>{row.areaName || "-"} </TableCell>
    <TableCell>{row.zoneName || "-"} </TableCell>
    <TableCell>{row.regionName || "-"} </TableCell>
    <TableCell>{row.chapterName || "-"} </TableCell>
    <TableCell>{row.districtName || "-"} </TableCell>
  </TableRow>
);

function FriendTransferBasicFields({
  setFieldValue,
  handleChange,
  values,
  selectedFriend,
  errors,
}) {
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [showAddress, setShowAddress] = useState(false);
  const [pincode, setPinCode] = useState(false);

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
    if (response?.data) {
      const filteredState = response.data.find((s) => {
        return s.stateId === Number(selectedFriend.state);
      });
      if (filteredState) {
        setFieldValue(
          FRIEND_TRANFER_REQUEST_FIELDS.STATE,
          filteredState.stateId
        );
        setCities(filteredState.cities);
        const filteredCity = filteredState.cities.find((c) => {
          return c.cityId === Number(selectedFriend.city);
        });
        if (filteredCity) {
          setFieldValue(
            FRIEND_TRANFER_REQUEST_FIELDS.CITY,
            filteredCity.cityId
          );
        }
      }
    }
  };

  useEffect(() => {
    getStates();
    getDivisions();
  }, []);

  const handleToggleChange = (e) => {
    setShowAddress(e.target.checked);
    setPinCode(e.target.checked);
    setFieldValue(
      FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS,
      e.target.checked ? selectedFriend.addressLine1 : ""
    );
    setFieldValue(
      FRIEND_TRANFER_REQUEST_FIELDS.STATE,
      e.target.checked ? Number(selectedFriend.state) : ""
    );
    setFieldValue(
      FRIEND_TRANFER_REQUEST_FIELDS.CITY,
      e.target.checked ? Number(selectedFriend.city) : ""
    );
    setFieldValue(
      FRIEND_TRANFER_REQUEST_FIELDS.PINCODE,
      e.target.checked ? selectedFriend.pincode : ""
    );
  };

  return (
    <div style={Styles.gridContainer}>
      <div style={Styles.prevText}>Same as Previous Address</div>
      <div style={Styles.inputContainer}>
        <SwitchButton value={showAddress} handleChange={handleToggleChange} />
      </div>
      <div style={Styles.name}>
        <InputField
          required
          label="Friend's Name"
          name={FRIEND_TRANFER_REQUEST_FIELDS.FRIEND_NAME}
          onChange={handleChange}
          containerStyle={Styles.inputContainer}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.FRIEND_NAME]}
          disabled={values[FRIEND_TRANFER_REQUEST_FIELDS.FRIEND_NAME]}
        />
      </div>
      <div>
        <InputField
          required
          label="New Address"
          name={FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS}
          onChange={handleChange}
          containerStyle={Styles.inputContainer}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS]}
          disabled={showAddress}
        />
      </div>
      <div>
        <InputField
          label="Pincode"
          containerStyle={Styles.inputContainer}
          name={FRIEND_TRANFER_REQUEST_FIELDS.PINCODE}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.PINCODE]}
          onChange={handleChange}
          inputProps={{
            maxLength: 6,
          }}
          disabled={pincode}
        />
      </div>
      {/* <div>
      <InputField
        label="New Address Line 2"
        name={FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS_LINE_2}
        onChange={handleChange}
        containerStyle={Styles.inputContainer}
        value={values[FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS_LINE_2]}
        disabled={showAddress}
      />
    </div> */}
      <div>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.stateName}
          label="State"
          name={FRIEND_TRANFER_REQUEST_FIELDS.STATE}
          options={getOptions(states, "stateId")}
          error={errors[FRIEND_TRANFER_REQUEST_FIELDS.STATE]}
          value={Number(values[FRIEND_TRANFER_REQUEST_FIELDS.STATE])}
          disabled={showAddress}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(FRIEND_TRANFER_REQUEST_FIELDS.STATE, "");
              setCities([]);
            } else {
              setFieldValue(
                FRIEND_TRANFER_REQUEST_FIELDS.STATE,
                selectedValue.value
              );
              setCities(selectedValue.cities);
            }
            setFieldValue(FRIEND_TRANFER_REQUEST_FIELDS.CITY, "");
          }}
        />
      </div>
      <div>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.cityName}
          label="City"
          name={FRIEND_TRANFER_REQUEST_FIELDS.CITY}
          options={getOptions(cities, "cityId")}
          error={errors[FRIEND_TRANFER_REQUEST_FIELDS.CITY]}
          value={Number(values[FRIEND_TRANFER_REQUEST_FIELDS.CITY])}
          disabled={!values[FRIEND_TRANFER_REQUEST_FIELDS.STATE] || showAddress}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(FRIEND_TRANFER_REQUEST_FIELDS.CITY, "");
            } else {
              setFieldValue(
                FRIEND_TRANFER_REQUEST_FIELDS.CITY,
                selectedValue.value
              );
            }
          }}
        />
      </div>
      <div>
        <InputField
          label="Date of Joining"
          containerStyle={Styles.inputContainer}
          name={FRIEND_TRANFER_REQUEST_FIELDS.DATE_OF_JOINING}
          value={convertDateTimeToDate(
            values[FRIEND_TRANFER_REQUEST_FIELDS.DATE_OF_JOINING]
          )}
          disabled={values[FRIEND_TRANFER_REQUEST_FIELDS.DATE_OF_JOINING]}
        />
      </div>
      <div style={Styles.gridItem} />
      <div>
        <InputField
          required
          label="Contact Number"
          containerStyle={Styles.inputContainer}
          name={FRIEND_TRANFER_REQUEST_FIELDS.CONTACT_NUMBER}
          onChange={handleChange}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.CONTACT_NUMBER]}
          inputProps={{
            maxLength: 10,
          }}
        />
      </div>
      <div>
        <InputField
          label="Email Address"
          containerStyle={Styles.inputContainer}
          name={FRIEND_TRANFER_REQUEST_FIELDS.EMAIL_ADDRESS}
          onChange={handleChange}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.EMAIL_ADDRESS]}
        />
      </div>
      <div>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Division"
          name={FRIEND_TRANFER_REQUEST_FIELDS.DIVISION}
          options={getOptions(divisions, "divisionId")}
          error={errors[FRIEND_TRANFER_REQUEST_FIELDS.DIVISION]}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.DIVISION]}
          disabled={values[FRIEND_TRANFER_REQUEST_FIELDS.DIVISION]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(FRIEND_TRANFER_REQUEST_FIELDS.DIVISION, "");
              setSubDivisions([]);
            } else {
              setFieldValue(
                FRIEND_TRANFER_REQUEST_FIELDS.DIVISION,
                selectedValue.value
              );
              setSubDivisions(selectedValue.subDivisions);
            }
            setFieldValue(FRIEND_TRANFER_REQUEST_FIELDS.SUB_DIVISION, "");
          }}
        />
      </div>
      <div>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Sub Division"
          name={FRIEND_TRANFER_REQUEST_FIELDS.SUB_DIVISION}
          options={getOptions(subDivisions, "divisionId")}
          error={errors[FRIEND_TRANFER_REQUEST_FIELDS.SUB_DIVISION]}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.SUB_DIVISION]}
          disabled={values[FRIEND_TRANFER_REQUEST_FIELDS.DIVISION]}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(FRIEND_TRANFER_REQUEST_FIELDS.SUB_DIVISION, "");
            } else {
              setFieldValue(
                FRIEND_TRANFER_REQUEST_FIELDS.SUB_DIVISION,
                selectedValue.value
              );
            }
          }}
        />
      </div>
      {values[FRIEND_TRANFER_REQUEST_FIELDS.DIVISION] === 52 ||
      values[FRIEND_TRANFER_REQUEST_FIELDS.DIVISION] === 53 ? (
        <>
          <div style={Styles.gridItem}>
            <InputField
              required
              label="Parent's Contact Number"
              name={FRIEND_TRANFER_REQUEST_FIELDS.PARENT_CONTACT_NUMBER}
              value={
                values[FRIEND_TRANFER_REQUEST_FIELDS.PARENT_CONTACT_NUMBER]
              }
              onChange={handleChange}
              error={
                errors[FRIEND_TRANFER_REQUEST_FIELDS.PARENT_CONTACT_NUMBER]
              }
              inputProps={{
                maxLength: 10,
              }}
            />
          </div>
          <div style={Styles.gridItem}>
            <InputField
              label="Parent's Email Address"
              name={FRIEND_TRANFER_REQUEST_FIELDS.PARENT_EMAIL_ADDRESS}
              error={errors[FRIEND_TRANFER_REQUEST_FIELDS.PARENT_EMAIL_ADDRESS]}
              value={values[FRIEND_TRANFER_REQUEST_FIELDS.PARENT_EMAIL_ADDRESS]}
              onChange={handleChange}
            />
          </div>
        </>
      ) : null}
      <div>
        <InputField
          required
          label="Introducer's Name"
          type="text"
          name={FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_NAME}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_NAME]}
          onChange={handleChange}
        />
      </div>
      <div>
        <InputField
          required
          label="Introducer's Contact Number"
          type="text"
          name={FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_MOBILE_NUMBER}
          value={
            values[FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]
          }
          onChange={handleChange}
          inputProps={{
            maxLength: 10,
          }}
        />
      </div>
      <div>
        <InputField
          label="Introducer's Email Address"
          type="text"
          name={FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_EMAIL}
          value={values[FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_EMAIL]}
          onChange={handleChange}
        />
      </div>
      <div>
        <InputField
          type="text"
          key="remark"
          name="remark"
          label="Remark"
          value={values.remark}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

function FriendTransferForm() {
  const TITLE = "Friend Transfer To - BSG";
  const selectedFriend = useSelector(
    (state) => state.view_friends.selectedFriend
  );
  const isLoading = useSelector(
    (state) => state.view_friends?.selectedFriend.isLoading
  );

  const [showToast, setShowToast] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const onBack = () => navigate(-1);

  const postData = async (values) => {
    try {
      const data = {
        ...values,
        remark: {
          data: { message: values.remark, event: "success" },
        },
      };
      const response = await FriendsApi.transferFriend({
        data,
        friendId: selectedFriend.friendId,
      });
      setTimeout(() => {
        setSuccess(true);
        navigate(`/${ROUTES.FRIEND_TRANSFER.path}`);
      }, 2000);
      if (response) {
        // const remarkResponse = await FriendsApi.addRemarkForFriendTransfer({
        //   friendId: selectedFriend.friendId,
        //   transfereRequestId: response.data.transferRequestId,
        //   data: remark,
        // });

        // console.log("Remark Response:", remarkResponse);
        setSuccess(true);
        setShowToast({
          message: "Form submitted successfully",
          severity: "success",
        });
      }
    } catch (err) {
      setShowToast({ message: err.message, severity: "error" });
      Sentry.captureException(err);
    }
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box>
        <CustomTable
          columns={FRIEND_TRANSFER_TO}
          rows={getRows(selectedFriend)}
        />
        <Formik
          initialValues={{
            nationalityId: selectedFriend?.nationalityId || 1,
            // ...selectedFriend,
            [FRIEND_TRANFER_REQUEST_FIELDS.FRIEND_NAME]:
              selectedFriend.fullName,
            [FRIEND_TRANFER_REQUEST_FIELDS.FRIEND_ID]: selectedFriend.friendId,
            [FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS]: "",
            [FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS_LINE_1]: "",
            // [FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS_LINE_2]: "",
            [FRIEND_TRANFER_REQUEST_FIELDS.STATE]: "",
            [FRIEND_TRANFER_REQUEST_FIELDS.CITY]: "",
            [FRIEND_TRANFER_REQUEST_FIELDS.PINCODE]: "",
            [FRIEND_TRANFER_REQUEST_FIELDS.DATE_OF_JOINING]:
              selectedFriend.createdAt,
            [FRIEND_TRANFER_REQUEST_FIELDS.CONTACT_NUMBER]:
              selectedFriend.mobileNumber,
            [FRIEND_TRANFER_REQUEST_FIELDS.EMAIL_ADDRESS]:
              selectedFriend.emailId,
            [FRIEND_TRANFER_REQUEST_FIELDS.DIVISION]: selectedFriend.divisionId,
            [FRIEND_TRANFER_REQUEST_FIELDS.SUB_DIVISION]:
              selectedFriend.subdivisionId,
            [ORGANIZATION_STRUCTURE_FIELDS.REGION]: "",
            [ORGANIZATION_STRUCTURE_FIELDS.ZONE]: "",
            [ORGANIZATION_STRUCTURE_FIELDS.AREA]: "",
            [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: "",
            [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: "",
            [FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_NAME]:
              selectedFriend?.introducerName,
            [FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]:
              selectedFriend?.introducerMobileNumber,
            [FRIEND_TRANFER_REQUEST_FIELDS.INTRODUCED_BY_EMAIL]:
              selectedFriend?.introducerEmail,
          }}
          onSubmit={debounce((values) => {
            const result = handleTransferValidation(NEW_ENTRY_FIELDS, values, [
              FRIEND_TRANFER_REQUEST_FIELDS.ADDRESS_LINE_1,
            ]);
            if (result && Object.keys(result).length) {
              setShowToast(result);
              return;
            }
            const { remark } = values;
            postData(values, remark);
          })}
        >
          {({
            values,
            errors,
            handleChange,
            handleSubmit,
            setFieldValue,
            /* and other goodies */
          }) => (
            <>
              <Box style={Styles.main}>
                <Box style={Styles.leftContainer}>
                  <FriendTransferBasicFields
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    selectedFriend={selectedFriend}
                  />
                </Box>
                <Box style={Styles.rightContainer}>
                  <OrganizationStructure
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    isLoading={false}
                    showZoneLocator
                  />
                </Box>
              </Box>
              {isLoading && <Loader />}
              <Divider
                sx={{
                  display: "flex",
                  width: "100%",
                  margin: "2rem 0",
                }}
              />
              <Button label="Submit" onClick={handleSubmit} />
              <Button
                variant="outlined"
                onClick={onBack}
                label="Cancel"
                style={{
                  marginLeft: "20px",
                }}
              />
            </>
          )}
        </Formik>
        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => {
            setShowToast(null);
          }}
        />
      </Box>
    </>
  );
}

export default FriendTransferForm;
